/**
 * External dependencies
 */
import memoize from 'memize'; // re-export due to restrictive esModuleInterop setting

export default memoize;
//# sourceMappingURL=memoize.js.map